import { apiClient, SEARCH_API_URL } from '.'

export async function fetchLangualRootDescriptors() {
  return apiClient.get('/langual').then((res) => res.data)
}

export async function fetchLanguaLParents(languaLID: string) {
  return apiClient.get(`/langual/${languaLID}/parent`).then((res) => res.data)
}

export async function fetchLanguaLChildren(languaLID: string) {
  return apiClient.get(`/langual/${languaLID}/children`).then((res) => res.data)
}
export async function searchLanguaL(name: string) {
  return apiClient.get(`/languaL?name=${name}`, {
    baseURL: SEARCH_API_URL,
  }).then((res) => res.data)
}
